export default __webpack_public_path__ + "static/media/CL-3.4a6343a0.png";